import { store } from '@redux/store';
import SortType from '../enums/sortType';
import { facetsSelector } from '../redux/selectors';
import ClearFilters from './clearFilters';

const clearButton = document.querySelector('[data-clear-filters]');
const clearFilters = new ClearFilters(clearButton);

/**
 * toggle the visibility of the clear all button
 * it should be hidden when no filter is applied, and be shown when there is 1 or more filters applied.
 * @param {Array} appliedFacets List of applied facets.
 */
const toggleClearAllButton = (appliedFacets) => {
  const facetsValues = facetsSelector(store.getState());
  const ignoredSorts = [SortType.CommunityId.toString()];

  if (appliedFacets.length > 0 &&
    !(appliedFacets.length === 1 && appliedFacets[0] === 'sort' &&
      ignoredSorts.includes(facetsValues?.sort))) {
    clearButton.removeAttribute('disabled');
  } else {
    clearButton.setAttribute('disabled', '');
  }
};

// subscribe to the observable and call the toggleClearAllButton function
clearFilters.onFacetsApplied$.subscribe(toggleClearAllButton);